import React from 'react'
import { Box, Typography, Divider } from '@mui/material'
import { TooltipProps } from 'recharts'
import { NameType, ValueType } from 'recharts/types/component/DefaultTooltipContent'
import { formatDateForTooltip, parseTimestamp } from '../../helpers'
import { useTranslation } from 'react-i18next'

interface GraphDataPoint {
  timestamp: string
  time: string
  formattedTime: string
  guest: number
  private: number
  other: number
}

const GraphTooltip: React.FC<TooltipProps<ValueType, NameType>> = ({ active, payload }) => {
  const { t } = useTranslation()
  
  if (!active || !payload || !payload.length) return null

  const firstPayload = payload[0]?.payload as GraphDataPoint | undefined
  const formattedDate = firstPayload?.timestamp 
    ? formatDateForTooltip(parseTimestamp(firstPayload.timestamp))
    : ''

  const visiblePayload = payload.filter(entry => Number(entry.value) > 0)

  if (!visiblePayload.length) return null

  const total = visiblePayload.reduce((sum, entry) => sum + Number(entry.value || 0), 0)

  return (
    <Box
      sx={{
        backgroundColor: 'white',
        border: '1px solid #E5E7EB',
        borderRadius: '8px',
        padding: '12px',
        boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)'
      }}
    >
      <Typography variant="caption" sx={{ fontWeight: 600, mb: 1, display: 'block' }}>
        {formattedDate}
      </Typography>
      {visiblePayload.map((entry) => (
        <Box key={entry.dataKey} sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.5 }}>
          <Box
            sx={{
              width: 8,
              height: 8,
              borderRadius: '50%',
              backgroundColor: entry.color
            }}
          />
          <Typography variant="caption" sx={{ fontSize: 11 }}>
            {entry.name}: <strong>{Math.ceil(Number(entry.value))}</strong>
          </Typography>
        </Box>
      ))}
      <Divider sx={{ my: 1 }} />
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <Typography variant="caption" sx={{ fontSize: 11, fontWeight: 600 }}>
          {t('kpis_widgets.connected_devices.total')}: <strong>{Math.ceil(total)}</strong>
        </Typography>
      </Box>
    </Box>
  )
}

export default GraphTooltip